module.exports = __webpack_public_path__ + "static/media/avatar4.e387f54e.png";